export default __webpack_public_path__ + "static/media/fauna-docs-framed.079fcb78.png";